import styled from '@emotion/styled'

export const BodyText = styled.div`
  font-family: Satoshi;
  font-weight: 400;
  font-size: 18px;
  line-height: 28px;
  letter-spacing: 0%;
  text-align: center;
`
